import * as i0 from '@angular/core';
import { Injectable, EventEmitter, Component, Renderer2, Inject, ChangeDetectorRef, Input, Output, ViewChild, ElementRef, NgModule } from '@angular/core';
import { ReplaySubject, Subject, from } from 'rxjs';
import { DOCUMENT, CommonModule } from '@angular/common';
import * as SharedLib from '@cumul.io/shared-cumulio-dashboard';

/** @dynamic */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';

const _c0 = ["container"];
const _c1 = function (a0) { return { color: a0 }; };
function NgxCumulioDashboardComponent_div_2_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 10);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngStyle", ɵngcc0.ɵɵpureFunction1(2, _c1, ctx_r4.loaderFontColor));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r4.loadingMsg, " ");
} }
const _c2 = function (a0) { return { chartEmbedding: a0 }; };
function NgxCumulioDashboardComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 4, 5)(2, "div", 6)(3, "div", 7);
    ɵngcc0.ɵɵelement(4, "div", 8);
    ɵngcc0.ɵɵtemplate(5, NgxCumulioDashboardComponent_div_2_div_5_Template, 2, 4, "div", 9);
    ɵngcc0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵpropertyInterpolate1("id", "cio-container-loader-", ctx_r1.paramsId, "");
    ɵngcc0.ɵɵproperty("ngStyle", ctx_r1.loaderStyle);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵpropertyInterpolate1("id", "cio-loader-", ctx_r1.paramsId, "");
    ɵngcc0.ɵɵproperty("ngStyle", ctx_r1.loaderStyles());
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngStyle", ctx_r1.lcStyles());
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngStyle", ctx_r1.plStyles())("ngClass", ɵngcc0.ɵɵpureFunction1(8, _c2, ctx_r1.params.itemEmbedding));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r1.params.itemEmbedding);
} }
function NgxCumulioDashboardComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 11)(1, "h3", 12);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵpropertyInterpolate1("id", "cio-error-", ctx_r2.paramsId, "");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r2.errorMsg);
} }
class NgxCumulioDashboardService {
    constructor() {
        this._components = [];
        this.activeDashboardsSource = new ReplaySubject(1);
    }
    getDashboards() {
        return this.activeDashboardsSource.asObservable();
    }
    _emitActiveDashboardsSource() {
        this.activeDashboardsSource.next(this._components);
    }
    _setComponentContext(componentContext) {
        if (!this._components.includes(componentContext)) {
            this._components.push(componentContext);
        }
    }
    // remove component context from array after unmounting
    _removeComponentContext(componentContext) {
        if (this._components.includes(componentContext)) {
            this._components = this._components.filter((context) => context !== componentContext);
        }
        this._emitActiveDashboardsSource();
    }
}
NgxCumulioDashboardService.ɵfac = function NgxCumulioDashboardService_Factory(t) { return new (t || NgxCumulioDashboardService)(); };
NgxCumulioDashboardService.ɵprov = i0.ɵɵdefineInjectable({ factory: function NgxCumulioDashboardService_Factory() { return new NgxCumulioDashboardService(); }, token: NgxCumulioDashboardService, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxCumulioDashboardService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

const _setEventHandler = (cumulioService) => {
    if (typeof window['__cumulioMessageHandler'] === 'function') {
        return;
    }
    window['__cumulioMessageHandler'] = (event) => {
        var _a;
        const dashboardComponent = cumulioService._components.find((c) => event.data.name === c.iframeId);
        if (!dashboardComponent) {
            return;
        }
        switch ((_a = event.data) === null || _a === void 0 ? void 0 : _a.type) {
            case 'load': {
                dashboardComponent.load.emit({ data: event.data });
                dashboardComponent.iframeLoaded = true;
                dashboardComponent.dimensions = event.data.dimensions;
                dashboardComponent.calculateDimAfterDashboardLoaded();
                cumulioService._emitActiveDashboardsSource();
                break;
            }
            case 'error': {
                dashboardComponent.error = true;
                dashboardComponent.iframeLoaded = true;
                dashboardComponent.calculateDimAfterDashboardLoaded();
                break;
            }
            case 'data': {
                SharedLib.resolvePromise(dashboardComponent, event.data.requestId, event.data.data);
                break;
            }
            case 'filters': {
                dashboardComponent.filters$.next(event.data.filters);
                SharedLib.resolvePromise(dashboardComponent, event.data.requestId, event.data.filters);
                break;
            }
            case 'getAccessibleDashboards': {
                SharedLib.resolvePromise(dashboardComponent, event.data.requestId, event.data.accessibleDashboards);
                break;
            }
            case 'dashboardAction': {
                dashboardComponent.dashboardAction.next({ data: event.data });
                break;
            }
            case 'changedFilters': {
                dashboardComponent.filters$.next(event.data.filters);
                dashboardComponent.changedFilters.emit({ data: event.data });
                break;
            }
            case 'customEvent': {
                dashboardComponent.customEvent.emit({ data: event.data });
                break;
            }
            case 'chartsRendered': // TODO remove once chartsRendered is changed to itemsRendered in FE app
            case 'itemsRendered': {
                dashboardComponent.itemsRendered.emit({ data: event.data });
                break;
            }
            case 'setEditMode': {
                if (!event.data.error) {
                    SharedLib.resolvePromise(dashboardComponent, event.data.requestId, event.data);
                    // Set editMode to update iframe dimensions!
                    dashboardComponent.params.editMode = event.data.editMode;
                    dashboardComponent.calculateDimAfterDashboardLoaded();
                }
                else {
                    // do something
                    SharedLib.rejectPromise(dashboardComponent, event.data.requestId, event.data);
                }
                break;
            }
            case 'setPreview': {
                if (!event.data.error) {
                    SharedLib.resolvePromise(dashboardComponent, event.data.requestId, event.data);
                }
                else {
                    SharedLib.rejectPromise(dashboardComponent, event.data.requestId, event.data);
                }
                break;
            }
            case 'export': {
                if (!event.data.error) {
                    dashboardComponent.exported.next({ data: event.data });
                    SharedLib.resolvePromise(dashboardComponent, event.data.requestId, event.data);
                }
                else {
                    SharedLib.rejectPromise(dashboardComponent, event.data.requestId, event.data);
                }
                break;
            }
            case 'setFilters': {
                event.data.error
                    ? SharedLib.rejectPromise(dashboardComponent, event.data.requestId, event.data)
                    : SharedLib.resolvePromise(dashboardComponent, event.data.requestId, event.data);
                break;
            }
        }
    };
    window.addEventListener('message', window['__cumulioMessageHandler'], false);
};

const VERSION = '4.0.0-ngx-cumulio';

const { DEFAULT_PARAMETERS, addTrailingSlash, EXTENTS } = SharedLib;
/** @dynamic */
class NgxCumulioDashboardComponent {
    constructor(renderer2, ngxCumulioService, document, changeDetectorRef) {
        this.renderer2 = renderer2;
        this.ngxCumulioService = ngxCumulioService;
        this.document = document;
        this.changeDetectorRef = changeDetectorRef;
        this.itemId = '';
        this.language = 'auto';
        this.screenMode = 'auto';
        this.switchScreenModeOnResize = true;
        this.editMode = 'view';
        // eslint-disable-next-line @angular-eslint/no-output-native
        this.load = new EventEmitter();
        this.itemsRendered = new EventEmitter();
        this.customEvent = new EventEmitter();
        this.changedFilters = new EventEmitter();
        this.dashboardAction = new EventEmitter();
        this.exported = new EventEmitter();
        this.filters$ = new Subject();
        // used by utils in shared lib
        this.browserNotSupported = [];
        this.VERSION = VERSION;
        this.params = SharedLib.cloneDeep(DEFAULT_PARAMETERS); // Param given from cumulio-dashboard
        // Bindings
        this.sanitizedUrl = ''; // Sanitize iframe resource URL
        this.iframeId = ''; // Iframe element Id
        this.paramsId = String.fromCharCode(65 + Math.floor(Math.random() * 26)) + Date.now(); // Used For IframeId and set in Cumulio Object
        this.containerId = SharedLib.s4() +
            SharedLib.s4() +
            '-' +
            SharedLib.s4() +
            '-' +
            SharedLib.s4() +
            '-' +
            SharedLib.s4() +
            '-' +
            SharedLib.s4() +
            SharedLib.s4() +
            SharedLib.s4(); // Container element Id
        this.loadingMsg = ''; // Loader message (Initializing...)
        this.errorMsg = ''; // Error message
        // Other variables
        this.dimensions = {}; // From window message event -- renderer2.listener
        this.iframeLoaded = false; // Used for showing loader and iframe
        this.error = false; // Renderer2 when type data = error (with wrong dashboardId for example) then error = true and iframe will show its error
        this.initialized = false; // iframe initialized
        this.iframeStyle = {};
        this.loaderStyle = {};
        this.promises = {};
        // CSS for style bindings
        this.loaderSize = 32;
        this.borderWidth = 3;
        this.minHeight = 400;
        this._reloadTriggerProperties = [
            'dashboardId',
            'dashboardSlug',
            'itemId',
            'language',
            'qeVersion',
            'screenMode',
            'switchScreenModeOnResize',
            'authToken',
            'authKey',
            'appServer',
            'apiHost'
        ];
    }
    // Resize Observer -> set new border width from container.element -> calculate new dimensions;
    onResize() {
        // Set width of container
        this.containerWidth = this.containerElement.nativeElement.offsetWidth;
        // Set the new screenMode if screenMode can be switched
        if (this.switchScreenModeOnResize) {
            for (const d of EXTENTS) {
                if (d.width[0] <= window.innerWidth &&
                    window.innerWidth <= d.width[1]) {
                    this.currentScreenMode = d.mode;
                }
            }
        }
        this.updateIframeStyles();
        // Calculate new dimensions
        if (this.iframeLoaded) {
            this.calculateDimAfterDashboardLoaded();
        }
    }
    /* --------------
    | Main Methods |
    ---------------*/
    ngOnInit() {
        // Check browser
        this.browserCheck();
        // Save input values into Cumulio object
        this.setOptions();
        // Extend and validate the params from cumulio-dashboard
        this.extendAndValidate();
        // Check for loader errors and set language initializing
        this.setLoaderData();
        // Get Iframe URL
        this.getIframeURL();
        // Initialized
        this.initialized = true;
        this.iframeStyle = SharedLib.calculateIframeStyles(this);
        this.loaderStyle = SharedLib.containerLoaderStyles(this);
        this.ngxCumulioService._setComponentContext(this);
        _setEventHandler(this.ngxCumulioService);
        this._resizeObserver = new ResizeObserver(() => {
            this.onResize();
        });
    }
    ngOnChanges(changes) {
        // Save input vars into Cumulio object + extend && validate
        this.browserCheck();
        if (Object.keys(changes).includes('editMode')) {
            //TODO: fix a bug where if editMode is changed before iframe is loaded, the values would persist and call inside setEditMode would fail
            // There's a check inside setEditMode which does some weird check.
            if (this.iframeLoaded) {
                this.setEditMode(changes.editMode.currentValue);
            }
        }
        // Standard Height
        this.error = false;
        // Save input values into Cumulio object
        this.setOptions();
        // Extend and validate the params from cumulio-dashboard
        this.extendAndValidate();
        if (!this.initialized) {
            return;
        }
        // Check for loader errors and set language initializing
        this.setLoaderData();
        // Generate iframe url
        if (Object.keys(changes)
            .some((property) => this._reloadTriggerProperties.includes(property))) {
            this.iframeLoaded = false;
            this.getIframeURL();
            this.updateIframeUrl();
        }
    }
    ngAfterViewInit() {
        var _a;
        if (!this.iframe) {
            // create iframe element dynamically.
            this.iframe = document.createElement('iframe');
            // <iframe class="cio-embed-dashboard" #iframe id={{iframeId}} name="{{iframeId}}" [src]="sanitizedUrl" [ngStyle] = "iframeStyle"></iframe>
            this.iframe.classList.add('cio-embed-dashboard');
            this.iframe.id = this.iframeId;
            this.iframe.name = this.iframeId;
            this.iframe.frameBorder = '0';
            this.iframe.setAttribute('src', this.sanitizedUrl);
            this.updateIframeStyles();
            this.containerElement.nativeElement.appendChild(this.iframe);
        }
        // Initial container width
        this.containerWidth = this.containerElement.nativeElement.offsetWidth;
        // Initial screenMode -> set currentScreenMode
        if (this.switchScreenModeOnResize && this.screenMode === 'auto') {
            for (const d of EXTENTS) {
                if (d.width[0] <= window.innerWidth && window.innerWidth <= d.width[1]) {
                    this.currentScreenMode = d.mode;
                }
            }
        }
        else {
            this.currentScreenMode = this.screenMode;
        }
        (_a = this._resizeObserver) === null || _a === void 0 ? void 0 : _a.observe(this.containerElement.nativeElement);
    }
    ngOnDestroy() {
        var _a;
        (_a = this._resizeObserver) === null || _a === void 0 ? void 0 : _a.disconnect();
        this.ngxCumulioService._removeComponentContext(this);
        // When there are no more components left, de-register cumulioMessageHandler
        if (this.ngxCumulioService._components.length === 0) {
            window.removeEventListener('message', window['__cumulioMessageHandler'], false);
            window['__cumulioMessageHandler'] = undefined;
        }
        this.renderer2.destroy();
        this.initialized = false;
        this.iframeLoaded = false;
    }
    updateIframeUrl() {
        SharedLib.updateIframeUrl(this.iframe, this.sanitizedUrl);
    }
    updateIframeStyles() {
        for (const key of Object.keys(this.iframeStyle)) {
            this.iframe.style[key] = this.iframeStyle[key];
        }
    }
    setLoaderData() {
        const { loadingMsg, errorMsg } = SharedLib.getLoader(this);
        this.loadingMsg = loadingMsg;
        this.errorMsg = errorMsg;
    }
    /* -----------------
    | Service Methods |
    -----------------*/
    browserCheck() {
        // Handle check browser error
        SharedLib._browserCheck(this);
    }
    calculateDimAfterDashboardLoaded() {
        this.iframeLoaded = true;
        this.loaderStyle = SharedLib.containerLoaderStyles(this);
        this.changeDetectorRef.detectChanges();
        SharedLib._setCalculatedDimensions(this);
        this.updateIframeStyles();
    }
    setOptions() {
        var _a;
        // Set params
        // Set inputs to params
        this.params.dashboardId = this.dashboardId;
        this.params.dashboardSlug = this.dashboardSlug;
        this.params.container = '#dashboard-' + this.containerId;
        this.params.language = this.language;
        this.params.qeVersion = this.qeVersion;
        this.params.screenMode = this.screenMode;
        this.params.switchScreenModeOnResize = this.switchScreenModeOnResize;
        this.params.itemId = this.itemId;
        this.params.editMode = this.editMode;
        if (this.timezoneId) {
            this.params.timezoneId = this.timezoneId;
        }
        if (this.mainColor) {
            this.params.mainColor = this.mainColor;
        }
        if (this.accentColor) {
            this.params.accentColor = this.accentColor;
        }
        // Optional values
        if (this.authToken) {
            this.params.token = this.authToken;
        }
        if (this.authKey) {
            this.params.key = this.authKey;
        }
        if (this.appServer) {
            this.params.appServer = addTrailingSlash(this.appServer);
        }
        if (this.apiHost) {
            this.params.apiHost = addTrailingSlash(this.apiHost);
        }
        else {
            const appServer = (_a = this.params.appServer) !== null && _a !== void 0 ? _a : '';
            this.params.apiHost = appServer.endsWith('cumul.io/')
                ? appServer.replace('app', 'api')
                : appServer;
        }
        if (this.itemDimensions) {
            this.params.itemDimensions = this.itemDimensions;
        }
        if (this.loaderBackground) {
            this.params.loaderBackground = this.loaderBackground;
        }
        if (this.loaderFontColor) {
            this.params.loaderFontColor = this.loaderFontColor;
        }
        if (this.loaderSpinnerColor) {
            this.params.loaderSpinnerColor = this.loaderSpinnerColor;
        }
        if (this.loaderSpinnerBackground) {
            this.params.loaderSpinnerBackground = this.loaderSpinnerBackground;
        }
        // paramsId + iframeId
        this.iframeId = 'cio-dashboard-' + this.paramsId;
    }
    extendAndValidate() {
        SharedLib._extendAndValidate(this);
    }
    getIframeURL() {
        this.sanitizedUrl = SharedLib.createIframeUrl(this);
    }
    /* ------------------------
    | NgStyling For Template |
    ------------------------*/
    containerStyles() {
        return SharedLib.containerStyles(this);
    }
    loaderStyles() {
        return SharedLib.loaderStyles(this);
    }
    lcStyles() {
        return SharedLib.lcStyles(this);
    }
    plStyles() {
        return SharedLib.plStyles(this);
    }
    getDashboards() {
        return this.ngxCumulioService.getDashboards();
    }
    getFilters() {
        SharedLib.getFilters(this, this.iframe);
        return this.filters$.asObservable();
    }
    exportDashboard(format) {
        return from(SharedLib.exportDashboard(this, this.iframe, format));
    }
    getData(itemId) {
        return from(SharedLib.getData(this, this.iframe, itemId));
    }
    setAuthorization(key, token) {
        return from(SharedLib.setAuthorization(this, this.iframe, key, token));
    }
    setFilters(itemId, filters) {
        return from(SharedLib.setFilters(this, this.iframe, itemId, filters));
    }
    refreshData(itemId) {
        return from(SharedLib.refreshData(this, this.iframe, itemId));
    }
    reloadDashboard() {
        return from(SharedLib.reloadDashboard(this, this.iframe));
    }
    getAccessibleDashboards() {
        return from(SharedLib.getAccessibleDashboards(this, this.iframe));
    }
    setEditMode(editMode) {
        return from(SharedLib.setEditMode(this, this.iframe, editMode));
    }
    setPreview(preview) {
        return from(SharedLib.setPreview(this, this.iframe, preview));
    }
}
NgxCumulioDashboardComponent.ɵfac = function NgxCumulioDashboardComponent_Factory(t) { return new (t || NgxCumulioDashboardComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(NgxCumulioDashboardService), ɵngcc0.ɵɵdirectiveInject(DOCUMENT), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
NgxCumulioDashboardComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NgxCumulioDashboardComponent, selectors: [["cumulio-dashboard"]], viewQuery: function NgxCumulioDashboardComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c0, 5, ElementRef);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.containerElement = _t.first);
    } }, inputs: { itemId: "itemId", language: "language", screenMode: "screenMode", switchScreenModeOnResize: "switchScreenModeOnResize", editMode: "editMode", dashboardId: "dashboardId", dashboardSlug: "dashboardSlug", qeVersion: "qeVersion", authToken: "authToken", authKey: "authKey", mainColor: "mainColor", accentColor: "accentColor", loaderBackground: "loaderBackground", loaderFontColor: "loaderFontColor", loaderSpinnerColor: "loaderSpinnerColor", loaderSpinnerBackground: "loaderSpinnerBackground", appServer: "appServer", apiHost: "apiHost", itemDimensions: "itemDimensions", timezoneId: "timezoneId" }, outputs: { load: "load", itemsRendered: "itemsRendered", customEvent: "customEvent", changedFilters: "changedFilters", dashboardAction: "dashboardAction", exported: "exported" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 4, vars: 4, consts: [[1, "dashboard-container", 3, "id", "ngStyle"], ["container", ""], ["class", "cio-container-loader", 3, "id", "ngStyle", 4, "ngIf"], [3, "id", 4, "ngIf"], [1, "cio-container-loader", 3, "id", "ngStyle"], ["loader", ""], [1, "cio-loader", 3, "id", "ngStyle"], [1, "cio-lc", 3, "ngStyle"], [1, "cio-pl", 3, "ngStyle", "ngClass"], ["class", "cio-lm", 3, "ngStyle", 4, "ngIf"], [1, "cio-lm", 3, "ngStyle"], [3, "id"], [1, "cio-error"]], template: function NgxCumulioDashboardComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0, 1);
        ɵngcc0.ɵɵtemplate(2, NgxCumulioDashboardComponent_div_2_Template, 6, 10, "div", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(3, NgxCumulioDashboardComponent_div_3_Template, 3, 2, "div", 3);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("id", "dashboard-" + ctx.containerId)("ngStyle", ctx.containerStyles());
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.error);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.error);
    } }, dependencies: [ɵngcc1.NgClass, ɵngcc1.NgIf, ɵngcc1.NgStyle], styles: ["[_nghost-%COMP%]{position:relative;width:100%}.cio-embed-dashboard[_ngcontent-%COMP%]{background:transparent;padding:0;border:0}.cio-container-loader[_ngcontent-%COMP%]{width:100%;position:relative}.cio-lc[_ngcontent-%COMP%]{margin:0 auto}.cio-lm[_ngcontent-%COMP%]{width:100%;height:20px;text-align:center;margin-bottom:16px;font-family:Helvetica,Arial,sans-serif;font-size:14px}.cio-pl[_ngcontent-%COMP%]{box-sizing:border-box;margin:16px auto;position:relative;text-indent:-9999em;animation:_ngcontent-%COMP%_spin .6s infinite linear}.cio-pl[_ngcontent-%COMP%], .cio-pl[_ngcontent-%COMP%]:after{border-radius:50%;width:32px;height:32px}.chartEmbedding[_ngcontent-%COMP%]:after{width:24px;height:24px}@keyframes _ngcontent-%COMP%_spin{0%{transform:rotate(0)}to{transform:rotate(360deg)}}.cio-error[_ngcontent-%COMP%]{background:transparent;padding:48px 0;margin:0 auto;width:80%;border:0;text-align:center;min-height:192px}.cio-loader[_ngcontent-%COMP%]{top:0;left:0;width:100%;min-height:400px;position:absolute;transition-duration:.3s}"] });
NgxCumulioDashboardComponent.ctorParameters = () => [
    { type: Renderer2 },
    { type: NgxCumulioDashboardService },
    { type: Document, decorators: [{ type: Inject, args: [DOCUMENT,] }] },
    { type: ChangeDetectorRef }
];
NgxCumulioDashboardComponent.propDecorators = {
    dashboardId: [{ type: Input }],
    dashboardSlug: [{ type: Input }],
    itemId: [{ type: Input }],
    language: [{ type: Input }],
    qeVersion: [{ type: Input }],
    screenMode: [{ type: Input }],
    switchScreenModeOnResize: [{ type: Input }],
    authToken: [{ type: Input }],
    authKey: [{ type: Input }],
    editMode: [{ type: Input }],
    mainColor: [{ type: Input }],
    accentColor: [{ type: Input }],
    loaderBackground: [{ type: Input }],
    loaderFontColor: [{ type: Input }],
    loaderSpinnerColor: [{ type: Input }],
    loaderSpinnerBackground: [{ type: Input }],
    appServer: [{ type: Input }],
    apiHost: [{ type: Input }],
    itemDimensions: [{ type: Input }],
    timezoneId: [{ type: Input }],
    load: [{ type: Output }],
    itemsRendered: [{ type: Output }],
    customEvent: [{ type: Output }],
    changedFilters: [{ type: Output }],
    dashboardAction: [{ type: Output }],
    exported: [{ type: Output }],
    containerElement: [{ type: ViewChild, args: ['container', { read: ElementRef },] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxCumulioDashboardComponent, [{
        type: Component,
        args: [{ selector: 'cumulio-dashboard', template: "<div\n  [id]=\"'dashboard-' + containerId\"\n  class=\"dashboard-container\"\n  #container\n  [ngStyle]=\"containerStyles()\"\n>\n  <div\n    *ngIf=\"!error\"\n    class=\"cio-container-loader\"\n    id=\"cio-container-loader-{{ paramsId }}\"\n    [ngStyle]=\"loaderStyle\"\n    #loader\n  >\n    <div\n      class=\"cio-loader\"\n      id=\"cio-loader-{{ paramsId }}\"\n      [ngStyle]=\"loaderStyles()\"\n    >\n      <div class=\"cio-lc\" [ngStyle]=\"lcStyles()\">\n        <div\n          class=\"cio-pl\"\n          [ngStyle]=\"plStyles()\"\n          [ngClass]=\"{ chartEmbedding: params.itemEmbedding }\"\n        ></div>\n        <div\n          *ngIf=\"!params.itemEmbedding\"\n          class=\"cio-lm\"\n          [ngStyle]=\"{ color: loaderFontColor }\"\n        >\n          {{ loadingMsg }}\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n<!--*ngIf=\"status.loaded && status.error\"-->\n<div *ngIf=\"error\" id=\"cio-error-{{ paramsId }}\">\n  <h3 class=\"cio-error\">{{ errorMsg }}</h3>\n</div>\n", styles: [":host{position:relative;width:100%}.cio-embed-dashboard{background:transparent;padding:0;border:0}.cio-container-loader{width:100%;position:relative}.cio-lc{margin:0 auto}.cio-lm{width:100%;height:20px;text-align:center;margin-bottom:16px;font-family:Helvetica,Arial,sans-serif;font-size:14px}.cio-pl{box-sizing:border-box;margin:16px auto;position:relative;text-indent:-9999em;animation:spin .6s infinite linear}.cio-pl,.cio-pl:after{border-radius:50%;width:32px;height:32px}.chartEmbedding:after{width:24px;height:24px}@keyframes spin{0%{transform:rotate(0)}to{transform:rotate(360deg)}}.cio-error{background:transparent;padding:48px 0;margin:0 auto;width:80%;border:0;text-align:center;min-height:192px}.cio-loader{top:0;left:0;width:100%;min-height:400px;position:absolute;transition-duration:.3s}\n"] }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }, { type: NgxCumulioDashboardService }, { type: Document, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }, { type: ɵngcc0.ChangeDetectorRef }]; }, { itemId: [{
            type: Input
        }], language: [{
            type: Input
        }], screenMode: [{
            type: Input
        }], switchScreenModeOnResize: [{
            type: Input
        }], editMode: [{
            type: Input
        }], load: [{
            type: Output
        }], itemsRendered: [{
            type: Output
        }], customEvent: [{
            type: Output
        }], changedFilters: [{
            type: Output
        }], dashboardAction: [{
            type: Output
        }], exported: [{
            type: Output
        }], dashboardId: [{
            type: Input
        }], dashboardSlug: [{
            type: Input
        }], qeVersion: [{
            type: Input
        }], authToken: [{
            type: Input
        }], authKey: [{
            type: Input
        }], mainColor: [{
            type: Input
        }], accentColor: [{
            type: Input
        }], loaderBackground: [{
            type: Input
        }], loaderFontColor: [{
            type: Input
        }], loaderSpinnerColor: [{
            type: Input
        }], loaderSpinnerBackground: [{
            type: Input
        }], appServer: [{
            type: Input
        }], apiHost: [{
            type: Input
        }], itemDimensions: [{
            type: Input
        }], timezoneId: [{
            type: Input
        }], containerElement: [{
            type: ViewChild,
            args: ['container', { read: ElementRef }]
        }] }); })();

class NgxCumulioDashboardModule {
    /**
     * @deprecated Will be removed in next major release.
     */
    static forRoot() {
        return {
            ngModule: NgxCumulioDashboardModule,
            providers: [NgxCumulioDashboardService],
        };
    }
}
NgxCumulioDashboardModule.ɵfac = function NgxCumulioDashboardModule_Factory(t) { return new (t || NgxCumulioDashboardModule)(); };
NgxCumulioDashboardModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: NgxCumulioDashboardModule });
NgxCumulioDashboardModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxCumulioDashboardModule, [{
        type: NgModule,
        args: [{
                declarations: [NgxCumulioDashboardComponent],
                imports: [CommonModule],
                exports: [NgxCumulioDashboardComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NgxCumulioDashboardModule, { declarations: function () { return [NgxCumulioDashboardComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [NgxCumulioDashboardComponent]; } }); })();

/*
 * Public API Surface of ngx-cumulio
 */

/**
 * Generated bundle index. Do not edit.
 */

export { NgxCumulioDashboardComponent, NgxCumulioDashboardModule, NgxCumulioDashboardService };

